module.exports = __webpack_public_path__ + "img/emails sent.ce9a575b.svg";